import { Link } from "react-router-dom";
import WorkCard from "@/components/base/WorkCard";
import SectionHeading from "@/components/base/SectionHeading";
import type { WorkItem } from "@/mocks/works";

export default function WorkShowcase({ items }: { items: WorkItem[] }) {
  return (
    <section>
      <SectionHeading
        title="作品精选"
        subtitle="最新与代表性影视作品，点击海报查看详情"
        action={
          <Link
            to="/works"
            className="hidden sm:inline-flex items-center gap-1 text-sm text-primary-600 hover:text-primary-700 font-body whitespace-nowrap"
          >
            查看全部作品
            <i className="ri-arrow-right-line"></i>
          </Link>
        }
      />
      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-3 md:gap-5">
        {items.map((item) => (
          <WorkCard key={item.id} item={item} />
        ))}
      </div>
    </section>
  );
}